import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import CountdownTimer from './CountdownTimer';

/**
 * Hero section with headline, subtitle, and primary CTA buttons.
 * @param {string} boardYear - e.g. "2026/27"
 * @param {string} deadline - The application deadline date.
 */
const HeroSection = ({ boardYear, deadline }) => {
  const scrollToPositions = () => {
    document.getElementById('positions-grid')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="text-center mb-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Badge */}
        <span className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wide text-[#D4AF37] uppercase bg-[#D4AF37]/10 border border-[#D4AF37]/20 rounded-full">
          Board Member Applications — {boardYear}
        </span>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight">
          Apply for the{' '}
          <span className="text-[#D4AF37]">{boardYear}</span>
          <br />
          <span className="text-white opacity-90">Board of Officials</span>
        </h1>

        {/* Subtitle */}
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-400 leading-relaxed mb-8">
          We are seeking passionate and dedicated individuals to serve on the{' '}
          {boardYear} Leo Club Board of Officials. Step up, lead with purpose,
          and shape the future of our club.
        </p>

        {/* Countdown Timer */}
        {deadline && <CountdownTimer deadline={deadline} />}

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToPositions}
            className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-[#D4AF37] to-[#B8860B] text-black rounded-2xl font-bold text-lg shadow-xl shadow-[#D4AF37]/20 flex items-center justify-center gap-3 group"
          >
            Apply for a Position{' '}
            <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
          </motion.button>

          <button
            onClick={scrollToPositions}
            className="w-full sm:w-auto px-8 py-4 bg-white/5 text-white border border-white/10 rounded-2xl font-bold text-lg hover:bg-white/10 transition-colors"
          >
            Explore Roles
          </button>
        </div>
      </motion.div>
    </header>
  );
};

export default HeroSection;
